import { IAppState } from '../../../AppModulesWrapper';

export function selectDepositAccountPaymentId(state: IAppState): string | null {
  return state.servicePickerWidget.depositAccount.paymentId;
}
